import requisicaoSegura from '@/auth/requisicaoSegura';
import { MetaTrack } from './pagamentos/types/pagamento';
import { APIResponse } from './types';

export type StatusMetaTrack =
  | 'view_page'
  | 'add_cart'
  | 'pay_now'
  | 'new_credit_card'
  | 'selected_previous_credit_card'
  | 'login_success'
  | 'login_error'
  | 'validate_sms_success'
  | 'validate_sms_error'
  | 'sign_up_personal_info_complete'
  | 'sign_up_contact_complete'
  | 'sign_up_success'
  | 'sign_up_error'
  | 'go_to_revision';

export async function enviarDadosMetaTrack({
  tracking,
  status,
}: {
  tracking: MetaTrack;
  status: StatusMetaTrack;
}): Promise<APIResponse> {
  const responseCancelarAssinatura: APIResponse = await requisicaoSegura({
    endpoint: '/Marketplace/EnviarTrackingNCM',
    dataForm: { tracking, status },
  });

  return responseCancelarAssinatura;
}
